<template>
    <div class="automation-action-settings">
        <div v-for="(setting, name) in action.settings" :key="name">
            
            <div v-if="!('depends_to' in setting) || (settings_values[setting.depends_to] == setting.depends_value)">

                <div class="field" v-if="!using_snippets[name]">
                    <label>{{ setting.label }}</label>

                    <div class="input-group" v-if="['number', 'text', 'email', 'url'].includes(setting.type)">
                        <div class="input-group-prepend" v-if="setting.prefix">
                            <span class="btn btn-dark">{{ setting.prefix }}</span>
                        </div>
                        <input class="form-control" v-model="settings_values[name]" :type="setting.type"
                            :required="setting.required" />
                        <div class="input-group-append" v-if="setting.suffix">
                            <span class="btn btn-dark">{{ setting.suffix }}</span>
                        </div>
                    </div>
                    <div class="input-group" v-if="['keyvalue'].includes(setting.type)">
                        <keyvalue v-model="settings_values[name]" :variant="setting.variant"></keyvalue>
                    </div>
                    <div class="input-group" v-if="['textarea'].includes(setting.type)">
                        <textarea class="form-control" v-model="settings_values[name]" :required="setting.required"></textarea>
                    </div>
                    <div class="input-group" v-if="['int'].includes(setting.type)">
                        <div class="input-group-prepend" v-if="setting.prefix">
                            <span class="btn btn-dark">{{ setting.prefix }}</span>
                        </div>
                        <input class="form-control" v-model="settings_values[name]" type="number" step="1" pattern="\d*"
                            :required="setting.required" />
                        <div class="input-group-append" v-if="setting.suffix">
                            <span class="btn btn-dark">{{ setting.suffix }}</span>
                        </div>
                    </div>
                    <div class="input-group" v-if="['money'].includes(setting.type)">
                        <div class="input-group-prepend">
                            <span class="btn btn-dark">{{
                                setting.prefix || t('currency_symbol')
                            }}</span>
                        </div>
                        <input class="form-control" name="fixed_amount" v-model="settings_values[name]" key="fixed-amount"
                            type="text" v-money="money" :required="setting.required" />
                        <div class="input-group-append" v-if="setting.suffix">
                            <span class="btn btn-dark">{{ setting.suffix }}</span>
                        </div>
                    </div>
                    <div class="input-group" v-if="setting.type === 'select' && (setting.searchable || setting.filter_by)">
                        <kv-select
                            :value="settings_values[name]"
                            :options="selectOptions(setting)"
                            :filterable="true"
                            :full-width="true"
                            :disabled="setting.filter_by && !settings_values[setting.filter_by]"
                            :placeholder="setting.filter_by && !settings_values[setting.filter_by]
                                ? t('automations-form-actions-plugin-select_parent_first')
                                : t('automations-form-actions-plugin-select_placeholder')"
                            :empty-text="t('automations-form-actions-plugin-select_empty')"
                            @input="setValue(name, $event)"
                        />
                    </div>
                    <div class="input-group" v-else-if="['select'].includes(setting.type)">
                        <select class="form-control" v-model="settings_values[name]" :required="setting.required">
                            <option v-for="option in setting.options" :key="option.value"
                                :selected="option.value == setting.default" :value="option.value">{{ option.label }}
                            </option>
                        </select>
                    </div>

                </div>

                <div class="field" v-else>
                    <label>{{ setting.label }}</label>
                    <div class="input-group">
                        <div class="input-group-prepend" v-if="setting.prefix">
                            <span class="btn btn-dark">{{ setting.prefix }}</span>
                        </div>
                        <input class="form-control" v-model="settings_values[name]" type="text"
                            :required="setting.required" />
                        <div class="input-group-append" v-if="setting.suffix">
                            <span class="btn btn-dark">{{ setting.suffix }}</span>
                        </div>
                    </div>
                </div>

                <div v-show="setting.allow_snippet && !['textarea', 'text'].includes(setting.type)" class="field">
                    <div class="input-group px-4">
                        <div class="d-flex">
                            <input @change="updateFieldForSnippets(name)" v-model="using_snippets[name]" :id="`check-input-${name}`" class="form-check-input"
                                :style="{ 'margin-top': '2.5px' }" type="checkbox" role="switch" />
                            <label class="mb-1" :for="`check-input-${name}`">{{ t('automations-form-actions-plugin-use_snippets_label') }}</label>
                        </div>
                    </div>
                </div>

            </div> </div> <div >
            <small>
                {{ t('automations-form-actions-plugin-snippets_help') }}
            </small>
            <small>
                <ul>
                    <li class="token" v-for="(token, t) in tokens" :key="t">
                        <span class="copy-token">{{ token }}</span>
                        <a @click="copyToken(token)" class="copy-btn"
                        ><i class="fa fa-copy"></i
                        ></a>
                    </li>
                </ul>
            </small>
        </div>
        <input id="tokenToCopy" v-model="tokenToCopy" type="text"/>

    </div>
</template>

<script>
import Keyvalue from "../../../components/inputs/keyvalue";
import KvSelect from "../../../components/inputs/kv-select.vue";

export default {
    components: { Keyvalue, KvSelect },
    props: {
        properties: Object,
        conditions: Array,
    },
    data: function () {
        return {
            tokenToCopy: "",
            action: this.properties.action,
            title: this.properties.action.name,
            description: this.properties.action.description,
            money: {
                decimal: ".",
                thousands: "",
                prefix: "",
                suffix: "",
                precision: 2,
            },
            using_snippets: this.properties?.using_snippets || {},
            settings_values: this.properties.settings_values || {},
        };
    },
    mounted: function () {
        this.$emit("mounted", this);
        this.$nextTick(() => {
            this.changed();
        });
    },
    computed: {
        trigger: function () {
            return this.$store.state.automationForm.trigger;
        },
        tokens: function () {
            return this.$store.getters["automationForm/tokens"](this.actionId);
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        copyToken(token) {
            this.tokenToCopy = token;
            this.$nextTick(() => {
                let tokenToCopyInput = document.querySelector("#tokenToCopy");
                tokenToCopyInput.select();
                if (document.execCommand("copy")) {
                    this.$store.dispatch("notification/success", {
                        text: this.t("automations-form-actions-plugin-token_copied"),
                        duration: 5000,
                    });
                }
            });
        },
        /**
         * Opções de um select. Com `filter_by`, só as que pertencem ao valor escolhido no outro campo
         * (`option.parents`), como as conversas de um destinatário.
         */
        selectOptions: function (setting) {
            const options = setting.options || [];
            if (!setting.filter_by) {
                return options;
            }
            const parent = this.settings_values[setting.filter_by];
            return parent ? options.filter((option) => (option.parents || []).includes(parent)) : [];
        },
        setValue: function (name, value) {
            this.$set(this.settings_values, name, value);
            // Quem depende deste campo perde o valor que deixou de pertencer à nova escolha.
            for (const [childName, child] of Object.entries(this.action.settings || {})) {
                if (child.filter_by !== name || !this.settings_values[childName]) continue;
                const stillValid = this.selectOptions(child).some((option) => option.value === this.settings_values[childName]);
                if (!stillValid) this.$set(this.settings_values, childName, "");
            }
            this.changed();
        },
        updateFieldForSnippets: function(name){
            this.settings_values[name] = "";
        },
        isValid: function () {
            return true;
        },
        changed: function () {
            this.$emit("propertiesUpdated", {
                action: this.action,
                settings_values: this.settings_values,
                using_snippets: this.using_snippets
            });
        },
    },
    watch: {
        settings_values: function () {
            this.changed();
        },
        action: function () {
            this.changed();
        },
    },
};
</script>
